import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { formatDateWithoutTZ } from '@brands/Utils/formatDate';
import { Divider } from '@mui/material';
import React from 'react';

import { CaseType, ICase } from '../../../../services/cases/types/ICase';
import { getFriendlyName } from '../../../../Utils/getFriendlyName';
import styles from '../../styles.module.scss';

type IConsultationHistory = {
  singleCase: ICase;
};

const ConsulationHistory = ({ singleCase }: IConsultationHistory): JSX.Element => {
  const roleNavigate = useRoleNavigate();

  const goToDetails = (): void => {
    const targetUrl =
      singleCase.type !== CaseType.smile_scan
        ? `/consultation-page/${singleCase.id}`
        : `/smile-scan-report/${singleCase.id}`;

    roleNavigate(targetUrl);
  };

  const date =
    singleCase.status === 'completed'
      ? singleCase.type !== CaseType.smile_scan
        ? formatDateWithoutTZ(singleCase.completed_at || '', true)
        : formatDateWithoutTZ(singleCase.updated_at || '', true)
      : formatDateWithoutTZ(singleCase.updated_at || '', true);

  return (
    <div className={styles.caseCard}>
      <div className={styles.caseHeader}>
        <h4 className={styles.caseTitle}>{getFriendlyName(singleCase.type)}</h4>
        <button className={styles.viewCase} onClick={goToDetails} type="button">
          View case
        </button>
      </div>

      <div className={styles.caseMeta}>
        <div className={styles.caseMetaDiv}>
          <span className={styles.label}>Date</span>
          <span className={styles.value}>{date}</span>
        </div>
        <Divider orientation="vertical" flexItem className={styles.divider} />
        <div className={styles.caseMetaDiv}>
          <span className={styles.label}>Case ID</span>
          <span className={styles.value}>{singleCase.id}</span>
        </div>
        <Divider orientation="vertical" flexItem className={styles.divider} />
        <div className={styles.caseMetaDiv}>
          <span className={styles.label}>Status</span>
          <span
            className={`${styles.statusPill} ${
              singleCase.status === 'completed' ? styles.completed : styles.inProgress
            }`}
          >
            {singleCase.status === 'completed' ? 'Complete' : 'In progress'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConsulationHistory;
